













import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { UserProgressTarget } from '@/models/profile';

@Component
export default class ProfileProgressbar extends Vue {
    @Prop(Object) public userProgressTarget: UserProgressTarget;
}
